'use strict';

var novicell = novicell || {};

novicell.featureComparison = novicell.featureComparison || function () {
    
    function init() {
        var featureComparison = document.querySelectorAll('.ship-list table');
        if(featureComparison.length){
            for(var i = 0; i < featureComparison.length;i++){
                var currentFeatureTable = featureComparison[i];
                
                //make wrappper
                wrap(currentFeatureTable,'div');
                currentFeatureTable.parentNode.classList.add('ship-list__tableHolderOuter');
                wrap(currentFeatureTable,'div');
                currentFeatureTable.parentNode.classList.add('o-featureComparison__tableHolderInner');
                
                //prepend clone
                var copyOfFeatureComparison = currentFeatureTable.cloneNode(true);
                copyOfFeatureComparison.classList.add('o-featureComparison__cloneTable');
                var featureComparisonParent =novicell.helpers.closestByClass(currentFeatureTable,'o-featureComparison__tableHolderOuter'); 
                featureComparisonParent.insertBefore(copyOfFeatureComparison, currentFeatureTable.parentNode);
            }
            
            var outerHolders = document.querySelectorAll('.o-featureComparison__tableHolderOuter');
            if(outerHolders.length){
                for(i = 0; i < outerHolders.length;i++){
                    var span = document.createElement('span');
                    span.classList.add('o-featureComparison__scrollInfo');
                    span.innerText=('Scroll »');
                    outerHolders[i].parentNode.insertBefore(span, outerHolders[i]);
                }
            }
        }
    }
    
    function wrap(selection, tag){
        var div = document.createElement(tag);
        selection.parentElement.insertBefore(div, selection);
        div.appendChild(selection); 
    }
    
    
    return {
        init: init
    };
    
}();